<template>
  <div class="offline-message flex justify-center">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
        <img src="@/assets/images/pages/maintenance-2.png" alt="graphic-maintenance" class="mx-auto mb-4">
        <h1 class="sm:mx-0 mx-4 mb-6 text-5xl d-theme-heading-color">Em Manutenção!</h1>
        <span class="sm:mx-0 mx-4 mb-1">
          Olá! Aqui é a Equipe da Pedbot.
        </span>
        <span class="sm:mx-0 mx-4 mb-1">
          Esperamos que estejam bem.
        </span>
<!--        <span class="sm:mx-0 mx-4 mb-6">-->
<!--          Queremos informar que na última semana enfrentamos algumas dificuldades técnicas  relacionadas aos servidores Google onde a plataforma Pedbot fica localizada, em decorrência destes problemas ocorreram instabilidades nos dias 14/03 e 15/03.-->
<!--        </span>-->
<!--        <span class="sm:mx-0 mx-4 mb-6">-->
<!--          Para garantir uma experiência mais estável e confiável para todos os nossos usuários, tomamos a decisão de migrar nossos serviços e passar a hospedá-los em novos servidores da Amazon (AWS). Estamos empenhados em oferecer o melhor serviço possível.-->
<!--        </span>-->
        <div class="sm:mx-0 mx-4 mb-6">
<!--           <span>-->
<!--             🛑 Devido a uma manutenção necessária, você poderá sentir algumas lentidões em nossa plataforma no período da manhã dessa sexta-feira (28/06). Em breve tudo já irá retornar ao normal, iremos notificá-los a cada atualização. 🛑-->
<!--           </span>-->
<!--          <span v-if="typeConnection && ['tenancy.low-1', 'tenancy.low-2'].includes(typeConnection)">-->
<!--            🛑Para realizar essa transição de forma eficiente, precisaremos deixar a plataforma fora do ar a partir das 13 horas de hoje (10/06) até as 16:30 horas. 🛑-->
<!--          </span>-->
<!--          <span v-else>-->
<!--            🛑Para realizar essa transição de forma eficiente, precisaremos deixar a plataforma fora do ar a partir das 13 horas de hoje (10/06) até as 15 horas. 🛑-->
<!--          </span>-->
        </div>
        <!--<span class="sm:mx-0 mx-4 mb-6">
          Para aprimorar a estabilidade de sua plataforma no Pedbot, faremos uma atualização de infraestrutura para todos os clientes.
          Por conta disso, iremos precisar de uma janela de manutenção na madrugada de Domingo às 00:00h até 07:00h, onde a plataforma irá ficar fora do ar e ao fim da atualização voltará a disponibilidade comum.
        </span>-->
        <span class="sm:mx-0 mx-4 mb-6">
          Atualmente, estamos passando por instabilidades temporárias que exigem nossa atenção imediata.
          Para garantir a qualidade e segurança da sua plataforma, ela precisará ficar offline por aproximadamente 20 minutos.
          Estamos trabalhando para restabelecer o serviço o mais rápido possível e agradecemos sua compreensão e paciência durante esse período.
        </span>
<!--        <span class="sm:mx-0 mx-4 mb-6">>-->
<!--          Pedimos desculpas por qualquer inconveniente causado por essa interrupção temporária.>-->
<!--          Agradecemos pela compreensão e paciência de todos vocês. Estaremos disponíveis para ajudar com qualquer dúvida ou preocupação que possam surgir durante esse processo.>-->
<!--        </span>>-->
        <span class="sm:mx-0 mx-4 mb-6">
          Agradecemos a compreensão.
        </span>
        <vs-button size="large" to="/">Página Inicial</vs-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'maintenance',
    data() {
      return {}
    },
    computed:{
      typeConnection() {
        return (localStorage.getItem('connectionDatabase') || null);
      }
    }
  }
</script>
